<template>
    <client-page class="wrap--sub">
        <!-- 서브비주얼 -->
        <sub-visual :visual="'전자제조지원센터'"></sub-visual>
        <div class="tab-list--primary-wrap">
            <ul class="tab-list tab-list--primary">
                <li class="on"><router-link to="/about" class="button">센터개요</router-link></li>
                <li><router-link to="/about/equipments" class="button">장비소개</router-link></li>
                <li><router-link to="/about/location" class="button">오시는 길</router-link></li>
                <!-- <li><router-link to="/about/business" class="button">사업개요</router-link></li> -->
            </ul>
        </div>

        <section class="section">
            <v-container>

                <section class="page-section">
                    <tit-primary
                    sc="용산전자제조지원센터 / KEA 가"
                    tit="원효전자상가(용산)내 Y-밸리에서 전자제조를 지원합니다.">
                    </tit-primary>

                    <div class="rounded mb-30 mb-lg-60">
                        <video controls preload="none" poster="/images/sub/about/about-img.jpg" class="w-100 d-block">
                            <source src="/res/video/1.mp4" type="video/mp4" />
                            Your browser does not support HTML5 video.
                        </video>
                    </div>

                    <div class="border-top border-2 border-color-black page-text color-grey">
                        <sub-list-primary
                        tit="소재지"
                        sc="서울시 용산구 청파로77 원효전자상가 6동 3층"
                        spacing="min-w-60px min-w-lg-80px mr-md-30 mr-xl-70">
                        </sub-list-primary>
                        <sub-list-primary
                        tit="전용면적"
                        sc="1,369㎡"
                        spacing="min-w-60px min-w-lg-80px mr-md-30 mr-xl-70">
                        </sub-list-primary>
                        <sub-list-primary
                        tit="공간구성"
                        sc="교육장, 세미나룸, 회의룸, 동영상스튜디오, PC조립장, 오픈디버깅랩, AS룸, 라운지, 1인작업공간"
                        spacing="min-w-60px min-w-lg-80px mr-md-30 mr-xl-70">
                        </sub-list-primary>
                        <sub-list-primary
                        tit="주요장비"
                        sc="전자부품실장라인, 보드조립라인(3개 제조라인), 모델링 지원장비(기구,외형), 전자제품 측정평가 및 실증장비 등"
                        spacing="min-w-60px min-w-lg-80px mr-md-30 mr-xl-70">
                        </sub-list-primary>
                    </div>
                </section>

                <section class="page-section">
                    <h4 class="tit--sm bar-txt">
                        소형가전 제조지원
                    </h4>
                    <div class="w-100 px-xl-32">
                        <v-row class="ma-xl-n34">
                            <v-col cols="6" sm="4" md="2" class="pa-xl-34">
                                <sub-icon-item-rounded
                                bgColor="#6f97f3"
                                icon="/images/sub/about/about/s1-icon1.svg"
                                tit="무게"
                                sc="10kg 이하">
                                </sub-icon-item-rounded>
                            </v-col>
                            <v-col cols="6" sm="4" md="2" class="pa-xl-34">
                                <sub-icon-item-rounded
                                bgColor="#4377eb"
                                icon="/images/sub/about/about/s1-icon2.svg"
                                tit="크기"
                                sc="30x30cm">
                                </sub-icon-item-rounded>
                            </v-col>
                            <v-col cols="6" sm="4" md="2" class="pa-xl-34">
                                <sub-icon-item-rounded
                                bgColor="#2e59b9"
                                icon="/images/sub/about/about/s1-icon3.svg"
                                tit="가격"
                                sc="30만원">
                                </sub-icon-item-rounded>
                            </v-col>
                            <v-col cols="6" sm="4" md="2" class="pa-xl-34">
                                <sub-icon-item-rounded
                                bgColor="#6f97f3"
                                icon="/images/sub/about/about/s1-icon4.svg"
                                tit="교체주기"
                                sc="2년이하">
                                </sub-icon-item-rounded>
                            </v-col>
                            <v-col cols="6" sm="4" md="2" class="pa-xl-34">
                                <sub-icon-item-rounded
                                bgColor="#4377eb"
                                icon="/images/sub/about/about/s1-icon5.svg"
                                tit="사용자반응 적용"
                                sc="환류(재설계)">
                                </sub-icon-item-rounded>
                            </v-col>
                            <v-col cols="6" sm="4" md="2" class="pa-xl-34">
                                <sub-icon-item-rounded
                                bgColor="#2e59b9"
                                icon="/images/sub/about/about/s1-icon6.svg"
                                tit="중간기술 기반"
                                sc="개발기간 6개월의 아이디어 소형가전">
                                </sub-icon-item-rounded>
                            </v-col>
                        </v-row>
                    </div>
                </section>

                <section class="page-section page-section--last">
                    <div class="rounded border">
                        <v-row no-gutters>
                            <v-col cols="12" md="4" lg="3">
                                <div class="h-100 pa-20 pa-md-30 px-lg-40 py-lg-50 border-bottom border-md-bottom-0 border-md-end" style="background-color: #ebf5ff">
                                    <h4 class="tit--sm font-weight-bold mb-20 mb-lg-34">
                                        KEA 전자제조센터
                                    </h4>
                                    <v-row class="ma-n4 ma-md-n6">
                                        <v-col cols="auto" md="12" class="pa-4 pa-md-6 d-flex align-center">
                                            <span class="num mr-6 mr-lg-8 page-text--sm">1</span>
                                            <p class="page-text color-grey">운영사무실</p>
                                        </v-col>
                                        <v-col cols="auto" md="12" class="pa-4 pa-md-6 d-flex align-center">
                                            <span class="num mr-6 mr-lg-8 page-text--sm">2</span>
                                            <p class="page-text color-grey">강의실(교육)</p>
                                        </v-col>
                                        <v-col cols="auto" md="12" class="pa-4 pa-md-6 d-flex align-center">
                                            <span class="num mr-6 mr-lg-8 page-text--sm">3</span>
                                            <p class="page-text color-grey">회의룸</p>
                                        </v-col>
                                        <v-col cols="auto" md="12" class="pa-4 pa-md-6 d-flex align-center">
                                            <span class="num mr-6 mr-lg-8 page-text--sm">4</span>
                                            <p class="page-text color-grey">공동 AS실</p>
                                        </v-col>
                                        <v-col cols="auto" md="12" class="pa-4 pa-md-6 d-flex align-center">
                                            <span class="num mr-6 mr-lg-8 page-text--sm">5</span>
                                            <p class="page-text color-grey">세미나룸(고개실증)</p>
                                        </v-col>
                                        <v-col cols="auto" md="12" class="pa-4 pa-md-6 d-flex align-center">
                                            <span class="num mr-6 mr-lg-8 page-text--sm">6</span>
                                            <p class="page-text color-grey">스튜디오</p>
                                        </v-col>
                                        <v-col cols="auto" md="12" class="pa-4 pa-md-6 d-flex align-center">
                                            <span class="num mr-6 mr-lg-8 page-text--sm">7</span>
                                            <p class="page-text color-grey">제조장비룸</p>
                                        </v-col>
                                        <v-col cols="auto" md="12" class="pa-4 pa-md-6 d-flex align-center">
                                            <span class="num mr-6 mr-lg-8 page-text--sm">8</span>
                                            <p class="page-text color-grey">측정평가룸</p>
                                        </v-col>
                                        <v-col cols="auto" md="12" class="pa-4 pa-md-6 d-flex align-center">
                                            <span class="num mr-6 mr-lg-8 page-text--sm">9</span>
                                            <p class="page-text color-grey">오픈실험실(디버깅랩)</p>
                                        </v-col>
                                        <v-col cols="auto" md="12" class="pa-4 pa-md-6 d-flex align-center">
                                            <span class="num mr-6 mr-lg-8 page-text--sm">10</span>
                                            <p class="page-text color-grey">공동PC조립장</p>
                                        </v-col>
                                        <v-col cols="auto" md="12" class="pa-4 pa-md-6 d-flex align-center">
                                            <span class="num mr-6 mr-lg-8 page-text--sm">11</span>
                                            <p class="page-text color-grey">1인작업공간</p>
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-col>
                            <v-col cols="12" md="8" lg="9" class="d-flex align-center justify-center pa-20 pa-md-30">
                                <v-img src="/images/sub/about/about/s1-img.jpg" max-width="818" class="w-100"></v-img>
                            </v-col>
                        </v-row>
                    </div>
                </section>

            </v-container>
        </section>

        <v-divider></v-divider>

        <section class="section">
            <v-container>
                <div class="tit-wrap text-center">
                    <h2 class="tit--lg font-weight-bold">
                        사업개요
                    </h2>
                </div>
                <div class="tabs-primary-wrap">
                    <v-tabs v-model="tab">
                        <v-tab>전자혁신 제조지원</v-tab>
                        <v-tab>스마트전자 확산/제조실증 기반구축</v-tab>
                        <v-tab>데이터분석기반 전자제조</v-tab>
                    </v-tabs>
                </div>
                <v-tabs-items v-model="tab">

                    <!-- S: 전자혁신 제조지원 -->
                    <v-tab-item>
                        <section class="page-section">
                            <v-row>
                                <v-col cols="12" md="6" class="mb-20 mb-md-0">
                                    <div class="pr-md-12 pr-xl-60">
                                        <div class="rounded w-100">
                                            <v-img src="/images/sub/about/about/s2-img1.jpg" class="w-100"></v-img>
                                        </div>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <div class="pt-md-12 pt-lg-24">
                                        <h3 class="tit font-weight-bold mb-8 mb-lg-20">
                                            전자혁신 제조지원
                                        </h3>
                                        <h5 class="tit-txt color-primary font-weghit-bold mb-20 mb-lg-54">
                                            2021.4월 ~ 2023.12월
                                        </h5>
                                        <div class="border-top border-2 border-color-black page-text color-grey">
                                            <sub-list-primary
                                            tit="지원내용"
                                            sc="빠른 제조, 부품지원, 상품화 등 전자제조서비스 지원"
                                            spacing="min-w-60px min-w-lg-80px mr-md-12 mr-xl-34">
                                            </sub-list-primary>
                                            <sub-list-primary
                                            tit="사업목표"
                                            sc="도심 내 전자혁신제조 플랫폼 구축으로 해외 이탈 전자 제조 수요를 국내로 복귀하여 전자제조 산업 르네상스 실현"
                                            spacing="min-w-60px min-w-lg-80px mr-md-12 mr-xl-34">
                                            </sub-list-primary>
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                        </section>
                        <section class="page-section page-section--last">

                            <sub-text-card bgColor="#2e59b9" tit="비전" className="mb-20 mb-lg-30">
                                <span class="color-primary">혁신제품 창출과 빠른지원을 통해 전자제조강국</span>에 기여한다.
                            </sub-text-card>

                            <v-img src="/images/sub/about/about/arrow.svg" max-width="132" class="mx-auto"></v-img>
                            
                            <sub-text-card bgColor="#4377eb" tit="목표" className="mt-n50 mt-lg-n36 position-relative">
                                <span class="color-primary">용산 [팩토리77] 구축을 통해 전자제조 집적화 확보</span> 및 용산 전자 집적화를 통한 혁신제품 개발 생태계 확보
                            </sub-text-card>

                            <div class="mt-50 mt-lg-220">
                                <sub-card-list tit="전략" className="mb-20 mb-lg-60 position-relative">
                                    <v-row class="page-text font-weight-bold text-center"> 
                                        <v-col cols="6" md="4">
                                            <div class="card card--shadow h-100 d-flex align-center justify-center">
                                                <p>
                                                    뉴 트랜드 제품기반의 <br class="d-none d-lg-block">
                                                    빠른 생산 시스템 구축
                                                </p>
                                            </div>
                                        </v-col>
                                        <v-col cols="6" md="4">
                                            <div class="card card--shadow h-100 d-flex align-center justify-center">
                                                <p>
                                                    도심 내 제조 생태계를 위한 <br class="d-none d-lg-block">
                                                    도시재생+산업재건 진행
                                                </p>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <div class="card card--shadow h-100 d-flex align-center justify-center">
                                                <p>
                                                    빠른 디버깅이 가능한 <br class="d-none d-lg-block">
                                                    인력+장비 공간 구축
                                                </p>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </sub-card-list>
                                <div class="arrow-image-wrap">
                                    <v-img src="/images/sub/about/about/arrow.svg" class="arrow-image mx-auto"></v-img>
                                    <sub-card-list tit="구성" class="arrow-wrap mt-n50 mt-lg-0 position-relative">
                                        <v-row class="page-text font-weight-bold text-center"> 
                                            <v-col cols="6" md="4">
                                                <div class="card card--shadow h-100 d-flex align-center justify-center">
                                                    <p>
                                                        빠른 제조를 통한 초도양산 지원
                                                    </p>
                                                </div>
                                            </v-col>
                                            <v-col cols="6" md="4">
                                                <div class="card card--shadow h-100 d-flex align-center justify-center">
                                                    <p>
                                                        엔지니어 상주를 통한 직접 기술 지원 <br class="d-none d-lg-block">
                                                        (언제니어+전문지원단)
                                                    </p>
                                                </div>
                                            </v-col>
                                            <v-col cols="12" md="4">
                                                <div class="card card--shadow h-100 d-flex align-center justify-center">
                                                    <p>
                                                        개발자를 위한 <br class="d-none d-lg-block">
                                                        제조 지원 / 인프라 지원
                                                    </p>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </sub-card-list>
                                </div>
                            </div>

                        </section>
                    </v-tab-item>
                    <!-- E: 전자혁신 제조지원 -->

                    <!-- S: 스마트전자 확산/제조실증 기반구축 -->
                    <v-tab-item>
                        <section class="page-section">
                            <v-row>
                                <v-col cols="12" md="6" class="mb-20 mb-md-0">
                                    <div class="pr-md-12 pr-xl-60">
                                        <div class="rounded w-100">
                                            <v-img src="/images/sub/about/about/s2-img2.jpg" class="w-100"></v-img>
                                        </div>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <div class="pt-md-12 pt-lg-24">
                                        <h3 class="tit font-weight-bold mb-8 mb-lg-20">
                                            스마트전자 확산, 제조실증 기반구축
                                        </h3>
                                        <h5 class="tit-txt color-primary font-weghit-bold mb-20 mb-lg-54">
                                            2021.4월 ~ 2025.12월
                                        </h5>
                                        <div class="border-top border-2 border-color-black page-text color-grey">
                                            <sub-list-primary
                                            tit="지원내용"
                                            sc="제품환류(제품 스케일업, 재설계 반복지원), 소비자실증 지원"
                                            spacing="min-w-60px min-w-lg-80px mr-md-12 mr-xl-34">
                                            </sub-list-primary>
                                            <sub-list-primary
                                            tit="사업목표"
                                            sc="전자제품의 스마트화, 소량제조, 환류, 유지보수를 지원할 수 있는 집적기반구축과 맞춤형 제조실증 지원을 통해 전자기업을 육성함"
                                            spacing="min-w-60px min-w-lg-80px mr-md-12 mr-xl-34">
                                            </sub-list-primary>
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                        </section>
                        <section class="page-section page-section--last">

                            <sub-text-card bgColor="#2e59b9" tit="비전" className="mb-20 mb-lg-30">
                                누구나 쉽게 혁신하자
                            </sub-text-card>

                            <v-img src="/images/sub/about/about/arrow.svg" max-width="132" class="mx-auto"></v-img>
                            
                            <sub-text-card bgColor="#4377eb" tit="목표" className="mt-n50 mt-lg-n36 position-relative">
                                용산 집적화를 통한 도심 전자생태계 확보
                            </sub-text-card>

                            <div class="mt-50 mt-lg-220">
                                <sub-card-list tit="전략" className="mb-20 mb-lg-60 position-relative">
                                    <v-row class="page-text font-weight-bold text-center"> 
                                        <v-col cols="6" md="4">
                                            <div class="card card--shadow h-100 d-flex align-center justify-center">
                                                <p>
                                                    제조, 개발자 제품의 <br class="d-none d-lg-block">
                                                    소비 트랜드 반영
                                                </p>
                                            </div>
                                        </v-col>
                                        <v-col cols="6" md="4">
                                            <div class="card card--shadow h-100 d-flex align-center justify-center">
                                                <p>
                                                    도심내 설계, 조립, 유지보수 <br class="d-none d-lg-block">
                                                    가능한 제조생태계 구축
                                                </p>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <div class="card card--shadow h-100 d-flex align-center justify-center">
                                                <p>
                                                    소비자 실증 및 환류가 <br class="d-none d-lg-block">
                                                    가능한 제조기반 구축
                                                </p>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </sub-card-list>
                                <div class="arrow-image-wrap">
                                    <v-img src="/images/sub/about/about/arrow.svg" class="arrow-image mx-auto"></v-img>
                                    <sub-card-list tit="구성" class="arrow-wrap mt-n50 mt-lg-0 position-relative">
                                        <v-row class="page-text font-weight-bold text-center"> 
                                            <v-col cols="6" md="4">
                                                <div class="card card--shadow h-100 d-flex align-center justify-center">
                                                    <p>
                                                        고객반응 및 실증이 <br class="d-none d-lg-block">
                                                        가능한 플렘폼 구축
                                                    </p>
                                                </div>
                                            </v-col>
                                            <v-col cols="6" md="4">
                                                <div class="card card--shadow h-100 d-flex align-center justify-center">
                                                    <p>
                                                        스마트 제품의 <br class="d-none d-lg-block">
                                                        조립, 제조, 실증 기반
                                                    </p>
                                                </div>
                                            </v-col>
                                            <v-col cols="12" md="4">
                                                <div class="card card--shadow h-100 d-flex align-center justify-center">
                                                    <p>
                                                        전자개발, 제조기업을 위한 <br class="d-none d-lg-block">
                                                        기술 집적지 구축
                                                    </p>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </sub-card-list>
                                </div>
                            </div>

                        </section>
                    </v-tab-item>
                    <!-- E: 스마트전자 확산/제조실증 기반구축 -->

                    <!-- S: 데이터분석기반 전자제조 -->
                    <v-tab-item>
                        <section class="page-section">
                            <v-row>
                                <v-col cols="12" md="6" class="mb-20 mb-md-0">
                                    <div class="pr-md-12 pr-xl-60">
                                        <div class="rounded w-100">
                                            <v-img src="/images/sub/about/about/s2-img3-1.jpg" class="w-100"></v-img>
                                        </div>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <div class="pt-md-12 pt-lg-24">
                                        <h3 class="tit font-weight-bold mb-8 mb-lg-20">
                                            데이터분석기반 전자제조 전문인력양성
                                        </h3>
                                        <h5 class="tit-txt color-primary font-weghit-bold mb-20 mb-lg-54">
                                            2021.3월 ~ 2026.2월
                                        </h5>
                                        <div class="border-top border-2 border-color-black page-text color-grey">
                                            <sub-list-primary
                                            tit="지원내용"
                                            sc="단기집중교육운영, 데이터 활용이 가능한 전자제조전문인력(年30명) 배출"
                                            spacing="min-w-60px min-w-lg-80px mr-md-12 mr-xl-34">
                                            </sub-list-primary>
                                            <sub-list-primary
                                            tit="사업목표"
                                            sc="스마트전자 산업의 전자제조생태계 기반으로 현장중심의 데이터기반 전자제조 혁신 인재양성"
                                            spacing="min-w-60px min-w-lg-80px mr-md-12 mr-xl-34">
                                            </sub-list-primary>
                                            <sub-list-primary
                                            tit="컨소시엄"
                                            sc="숭실대(전자), 숙명여대(경영분석), 서울과기대(데이터사이언스), KEA(제조/장비)"
                                            spacing="min-w-60px min-w-lg-80px mr-md-12 mr-xl-34">
                                            </sub-list-primary>
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                        </section>
                        <section class="page-section page-section--last">

                            <sub-text-card bgColor="#2e59b9" tit="추진목표">
                                용산 전자지구의 제조장비, 생태계, 고객데이터를 활용한 교육프로그램 운영을 통해 <br class="d-none d-lg-block">
                                전자+제조+데이터+경영에 대한 이해도가 높은 산업혁신인재 양성
                            </sub-text-card>

                            <div class="mt-50 mt-lg-220">
                                <sub-card-list tit="추진전략" className="mb-20 mb-lg-60 position-relative">
                                    <v-row class="page-text font-weight-bold text-center"> 
                                        <v-col cols="6" md="3">
                                            <div class="card card--shadow h-100 d-flex align-center justify-center">
                                                <p>
                                                    용산 전자지구 기반
                                                    현장교육 (전자특화지역)
                                                </p>
                                            </div>
                                        </v-col>
                                        <v-col cols="6" md="3">
                                            <div class="card card--shadow h-100 d-flex align-center justify-center">
                                                <p>
                                                    제조장비를 통한 전주기 교육
                                                    (Y-Factory77+용산상상가)
                                                </p>
                                            </div>
                                        </v-col>
                                        <v-col cols="6" md="3">
                                            <div class="card card--shadow h-100 d-flex align-center justify-center">
                                                <p>
                                                    대학별 특화 및 유기적 협력을
                                                    통한 융합교육
                                                </p>
                                            </div>
                                        </v-col>
                                        <v-col cols="6" md="3">
                                            <div class="card card--shadow h-100 d-flex align-center justify-center">
                                                <p>
                                                    산학 프로젝트 및 제품
                                                    데이터 분석을 통한 전문가 양성
                                                </p>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </sub-card-list>
                                <div class="arrow-image-wrap">
                                    <v-img src="/images/sub/about/about/arrow.svg" class="arrow-image mx-auto"></v-img>
                                    <sub-card-list tit="추진방안" class="arrow-wrap mt-n50 mt-lg-0 position-relative">
                                        <v-img src="/images/sub/about/about/s2-img3-2.jpg" max-width="933" class="mx-auto w-100 mb-8 mb-lg-20"></v-img>
                                        <h5 class="tit-txt font-weight-bold text-center">
                                            특화 집중교육 / 장비기반교육 / 지역산업교육 / 교육과정지역 신설 / 대학별 협력 / 취업 활성화
                                        </h5>
                                    </sub-card-list>
                                </div>
                            </div>

                        </section>
                    </v-tab-item>
                    <!-- E: 데이터분석기반 전자제조 -->

                </v-tabs-items>
            </v-container>
        </section>

    </client-page>
</template>

<script>
import SubVisual from "@/components/client/sub/sub-visual.vue";
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import AboutBusiness from "@/components/client/sub/about-business/about-business.vue";
import TitPrimary from "@/components/client/dumb/tit-primary.vue";
import SubListPrimary from "@/components/client/sub/sub-list-primary.vue";
import SubIconItemRounded from "@/components/client/sub/sub-icon-item--rounded.vue";
import SubTextCard from "@/components/client/sub/sub-text-card.vue";
import SubCardList from "@/components/client/sub/sub-card-list.vue";
export default {
    components: {
        SubVisual,
        ClientPage,
        AboutBusiness,
        TitPrimary,
        SubListPrimary,
        SubIconItemRounded,
        SubTextCard,
        SubCardList,
    },
    data() {
        return {
            tab: null,
        };
    },
};
</script>

<style scoped>
.num{
    min-width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    text-align: center;
    background-color: #2e59b9;
    border-radius: 50%;
    color: #fff;
}
@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .num{
        min-width: 24px;
        height: 24px;
    }
}
@media (min-width:1200px){
}

</style>
